<template>
  <v-toolbar
    flat
    class="ma-4"
  >
    <v-text-field
        v-model="searchModel"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        style="max-width: 300px"
    ></v-text-field>
    <v-spacer></v-spacer>
    <v-btn
        color="primary"
        dark
        :disabled="addNewDisabled"
        @click="$emit('clickAdd')"
    >
      New Item
    </v-btn>
  </v-toolbar>
</template>
<script>
export default {
  name: 'Toolbar',
  props: {
    addNewDisabled: {
      type: Boolean,
      required: true,
    },
    search: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      searchModel: this.search,
    };
  },

  watch: {
    searchModel() {
      this.$emit('update:search', this.searchModel);
    },
  },
};
</script>
